export default "__VITE_ASSET__f1601866__"